import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = (diameter, color, fontSize) => makeStyles(() => ({
    warning: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `3px solid ${color}`,
        fontSize,
        borderRadius: '50%',
        width: diameter,
        height: diameter,
        cursor: 'pointer',
    },
}));
export const RingWarning = (props) => {
    const { diameter, color, amount, fontSize, onClick } = props;
    const classes = useStyles(diameter, color, fontSize)();
    return (React.createElement("div", { className: classes.warning, onClick: onClick }, amount));
};
//# sourceMappingURL=RingWarning.js.map